import React, { useContext } from 'react'

import { usePageView } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { OwsContext } from './OwsContext'
import { usePageTitle } from '../app/PageTitleContext'

export default function OwsRawData() {
  const { t } = useTranslation()
  usePageView({ page_detail: 'DMConsole:OWSRawData' })
  usePageTitle(t('pageTitle.ows.rawData'))

  const owsContext = useContext(OwsContext)
  const currentOws = owsContext.currentOws

  return currentOws && <pre id="OWS Raw Data">{JSON.stringify(currentOws, null, 4)}</pre>
}
